export default "__VITE_PUBLIC_ASSET__13dadb00__"